import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { store } from '../../store'
import tts from '../../lib/TTS'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

const INTERVAL_OF_IMAGE_SWITCHING = 5 * 1000
const INACTIVITY_DURATION = 15 * 60 * 1000
// const INACTIVITY_DURATION = 10 * 1000 //Un-comment to test screensaver

class Screensaver extends React.Component {
  constructor(props) {
    super(props)
    this.screensaverIntervalId = null
    this.screensaverTimeoutId = null
    this.state = {
      activeIndex: 1,
      showScreensaver: false,
      srcOne: null,
      srcTwo: null,
      isEven: true,
    }
  }

  componentDidUpdate(prevProps) {
    const hasUserInteractedWithTheApp =
      prevProps.lastInteraction !== this.props.lastInteraction
    if (this.props.screensaverImages) {
      if (hasUserInteractedWithTheApp) {
        this.cancelScreensaver()
      } else {
        //If there is no interaction, it falls in the case of deeplink or the screensaver is showed
        if (!this.screensaverTimeoutId) {
          this.setScreensaverTimeout()
        }
      }
    }
  }

  cancelScreensaver() {
    if (this.state.showScreensaver) {
      tts.addTextToRead('Stopping screensaver')
      this.setState({
        showScreensaver: false,
      })
    }
    this.clearScreensaverTimeout()
    this.clearScreensaverInterval()

    if (!this.screensaverTimeoutId) {
      this.setScreensaverTimeout()
    }
  }

  clearScreensaverInterval() {
    if (this.screensaverIntervalId) {
      clearInterval(this.screensaverIntervalId)
      this.screensaverIntervalId = null
    }
  }

  clearScreensaverTimeout() {
    clearTimeout(this.screensaverTimeoutId)
    this.screensaverTimeoutId = null
  }

  setScreensaverTimeout() {
    this.screensaverTimeoutId = setTimeout(() => {
      const locationPathName = this.props.router.location.pathname

      const forbiddenComponents = ['exitAppButton', 'cancelButton']
      const interactingWithComponents = forbiddenComponents.includes(
        window.focusedComponent.componentType
      )

      const interactingWithPlayers =
        locationPathName.includes('video-playback') ||
        locationPathName.includes('live-playback')

      const ignoreScreensaver =
        interactingWithComponents || interactingWithPlayers

      if (!ignoreScreensaver) {
        tts.stopRead()
        tts.addTextToRead('Starting screensaver')
        this.setState({
          showScreensaver: true,
        })
        store.dispatch({
          type: 'SCREENSAVER_VISIBILITY',
          payload: true,
        })
        this.setScreensaverInterval()
      }
    }, INACTIVITY_DURATION)
  }

  setScreensaverInterval() {
    this.setState({
      activeIndex: 0,
      srcOne: this.props.screensaverImages[0],
    })
    this.screensaverIntervalId = setInterval(() => {
      const nextIndex =
        this.state.activeIndex < this.props.screensaverImages.length - 1
          ? this.state.activeIndex + 1
          : 0
      if (this.state.isEven) {
        this.setState({
          srcTwo: this.props.screensaverImages[nextIndex],
          activeIndex: nextIndex,
        })
      } else {
        this.setState({
          srcOne: this.props.screensaverImages[nextIndex],
          activeIndex: nextIndex,
        })
      }
      setTimeout(() => {
        this.setState({
          isEven: !this.state.isEven,
        })
      }, INTERVAL_OF_IMAGE_SWITCHING / 2)
    }, INTERVAL_OF_IMAGE_SWITCHING)
  }

  render() {
    const { showScreensaver, srcOne, srcTwo, isEven } = this.state
    const formatString = '?format=webp&resize=1280x720'
    return (
      <>
        {showScreensaver && (
          <div className="screensaver-modal-container">
            <div
              className="img-container"
              style={{
                animation: PLATFORM_HAS_SCREENSAVER_ANIMATION
                  ? 'move 40s infinite'
                  : 'none',
              }}
            >
              <div className={isEven ? 'active' : ''}>
                <img src={`${srcOne}${formatString}`} />
              </div>
              <div className={isEven ? '' : 'active'}>
                <img src={`${srcTwo}${formatString}`} />
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    screensaverImages: state.screensaver.screensaverImages,
    showing: state.screensaver.showing,
    lastInteraction: state.screensaver.lastInteraction,
    callsign: state.station.callsign,
  }
}
Screensaver.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  screensaverImages: PropTypes.array,
  showing: PropTypes.bool,
  callsign: PropTypes.string,
  lastInteraction: PropTypes.number,
}

export default connect(mapStateToProps, null, null)(withRouter(Screensaver))
